import { Box } from '@chakra-ui/react';
import QRCodeStyling, { Options, DotType, CornerSquareType } from 'qr-code-styling';
import { useEffect, useRef, useState } from 'react';
import type { QRCodeBoxProps } from './types';

export const QRCodeBox = ({ data, width = 184, height = 184 }: QRCodeBoxProps) => {
  const qrRef = useRef<HTMLDivElement>(null);
  const [qrCode, setQrCode] = useState<QRCodeStyling>();

  const getQrOptions = (): Options | null => {
    if (!data) return null;
    return {
      width,
      height,
      data,
      dotsOptions: {
        color: '#000000',
        type: 'extra-rounded' as DotType,
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      cornersSquareOptions: {
        type: 'extra-rounded' as CornerSquareType,
      },
    };
  };

  useEffect(() => {
    const options = getQrOptions();
    if (!options) return;

    const qr = new QRCodeStyling(options);
    setQrCode(qr);
  }, [data, width, height]);

  useEffect(() => {
    if (qrRef.current && qrCode) {
      qrCode.append(qrRef.current);
    }
  }, [qrCode]);

  useEffect(() => {
    const options = getQrOptions();
    if (!qrCode || !options) return;

    qrCode.update(options);
  }, [qrCode, data, width, height]);

  return <Box ref={qrRef} />;
};
